
export const handleDetectGPS = ({ setLoading, handleLocationUpdate }) => {
    if (!navigator.geolocation) {
        alert("Browser tidak mendukung Geolocation");
        return;
    }

    setLoading(true);
    navigator.geolocation.getCurrentPosition(
        (position) => {
            const { latitude, longitude } = position.coords;
            // Panggil fungsi terpusat kita
            handleLocationUpdate(latitude, longitude);
            setLoading(false);
        },
        (error) => {
            console.error(error);
            alert("Gagal mendapatkan lokasi. Pastikan GPS aktif.");
            setLoading(false);
        },
        {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
        }
    );
};